import React from 'react';

export const TokenExpiredIcon = () => {
  return <div className="token-expired-icon" />;
};
